import React, { useEffect, useState } from 'react';

import * as server from './server';
import * as helpers from './helpers';
import { GamesFeaturesContext } from './context';

export const withGameFeatures = (WrappedComponent) => (props) => {
    const [gamesFeatures, setGamesFeatures] = useState({});

    useEffect(() => {
        server.getGameZoneCollection()
            .then(({ data = {} }) => setGamesFeatures(helpers.filterGamesFeatures(data.games)));
    }, []);

    return (
        <GamesFeaturesContext.Provider value={gamesFeatures}>
            <WrappedComponent {...props} />
        </GamesFeaturesContext.Provider>
    );
};
